import { Environment } from './types';

const mitigationOrIlfUrlMap = {
  local: {
    mitigationBank: import.meta.env.VITE_MITIGATION_BANK_RIBITS_BASE_URL,
    inLieuFee: import.meta.env.VITE_INLIEUFEE_RIBITS_BASE_URL,
  },
  development: {
    mitigationBank: import.meta.env.VITE_MITIGATION_BANK_RIBITS_BASE_URL,
    inLieuFee: import.meta.env.VITE_INLIEUFEE_RIBITS_BASE_URL,
  },
  test: {
    mitigationBank: import.meta.env.VITE_MITIGATION_BANK_RIBITS_BASE_URL_TEST,
    inLieuFee: import.meta.env.VITE_INLIEUFEE_RIBITS_BASE_URL_TEST,
  },
  prod: {
    mitigationBank: import.meta.env.VITE_MITIGATION_BANK_RIBITS_BASE_URL_PROD,
    inLieuFee: import.meta.env.VITE_INLIEUFEE_RIBITS_BASE_URL_PROD,
  },
};

export const currentEnv = (import.meta.env.VITE_ENVIRONMENT || 'development') as Environment;
export const mitigationOrIlfUrls = mitigationOrIlfUrlMap[currentEnv] || mitigationOrIlfUrlMap.development;

export const getSearchParams = (query: string) =>
  '?' +
  new URLSearchParams({
    query,
    endPointSuffix: 'list',
  });
